import React from 'react'
import ReactDOM from 'react-dom'
import CartPage from 'cart/cart_page.jsx'

document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('cart_page')
  ReactDOM.render(<CartPage />, mount)
})
